import { SmallBasicModal } from '@liveoptics/react-ui';
import React, { useCallback, useState } from 'react';
import { TheaterType, VerifyOwnerState } from '../../../enums';
import { SalesforceInfo } from '../../../interfaces';
import { SetOpportunityForm } from '../../forms';
import { VerifyOwnerSuccessModal } from '../verify-owner-success/VerifyOwnerSuccessModal';

export interface SetOpportunityModalProps {
  projectId: number;
  defaultTheater: TheaterType;
  defaultSalesforceInfo: SalesforceInfo;
  onClose: () => void;
  onSuccess: () => void;
}

export const SetOpportunityModal = (props: SetOpportunityModalProps) => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successModalState, setSuccessModalState] = useState<VerifyOwnerState>(
    VerifyOwnerState.SelectOwner
  );

  const handleSuccess = useCallback(
    (state: VerifyOwnerState) => {
      setShowSuccessModal(true);
      setSuccessModalState(state);
      props.onSuccess();
    },
    [props]
  );

  return showSuccessModal ? (
    <VerifyOwnerSuccessModal state={successModalState} email={''} onClose={props.onClose} />
  ) : (
    <SmallBasicModal onClose={props.onClose} modalTitle="Link Opportunity ID">
      <SetOpportunityForm
        projectId={props.projectId}
        defaultTheater={props.defaultTheater}
        defaultSalesforceInfo={props.defaultSalesforceInfo}
        onCancel={props.onClose}
        onSuccess={handleSuccess}
      />
    </SmallBasicModal>
  );
};
